import React from 'react'
import { inject, observer } from 'mobx-react'
import MarkerLayer from './MarkerLayer'

const TemporaryMarkerLayer = ({ dataStore, uiStore }) => {
  const poi = dataStore && dataStore.poi
  if (!poi || !poi.temporaryMarkers) return null

  // Only render truly temporary / unsaved markers on the map.
  const markersToRender = poi.temporaryMarkers.filter(marker => {
    if (!marker) return false
    if (marker.savedMarkerId) return false
    const idStr = String(marker.id || '')
    if (idStr.startsWith('saved_')) return false
    return true
  })

  return (
    <>
      {markersToRender.map(marker => (
        <MarkerLayer
          key={marker.id}
          marker={marker}
          className='temporary-marker'
        />
      ))}
    </>
  )
}

export default inject('dataStore', 'uiStore')(
  observer(TemporaryMarkerLayer)
)
